import { HeaderThemeProps } from '../types/_theme';

const headerClasses = 'z-40 hidden text-[1.05rem] leading-6 lg:block';
const headerContainerThemeClasses = 'xl:max-w-7xl';
const headerNavContainerThemeClasses = 'h-full';
const headerBehaviorClasses = '';
const headerColorClasses = 'bg-blue-800 text-white';
const headerShadowClasses = '';
const headerInvisibleClasses = '';

const headerBlogTheme = (_: HeaderThemeProps) => ({
  headerClasses,
  headerContainerThemeClasses,
  headerNavContainerThemeClasses,
  headerBehaviorClasses,
  headerColorClasses,
  headerShadowClasses,
  headerInvisibleClasses,
});

export default headerBlogTheme;
